const LIVE_CHAT_CONSTANTS = {
    JOIN_ROOM: 'liveChat:joinRoom',
    SEND_MESSAGE: 'liveChat:sendMessage',
    NEW_MESSAGE: 'liveChat:newMessage',
    DELETE_MESSAGE: 'liveChat:deleteMessage',
    UPDATE_MESSAGE: 'liveChat:updateMessage',
    ENTER_GAME_ROOM: 'liveChat:enterGameRoom',
    UPDATE_SCORE: 'liveChat:updateScore',
    UPDATE_GAME_STATUS: 'liveChat:updateGameStatus',
    UPDATE_GAME_TIMER: 'liveChat:updateGameTimer',
    UPDATE_GAME_SESSION: 'liveChat:updateGameSession',
    UPDATE_PLAYERS: 'liveChat:updatePlayers',
    UPDATE_CURRENT_TIMESTAMP: 'liveChat:updateCurrentTimestamp',
    UPDATE_BASKET_ZONE: 'liveChat:updateBasketZone',
    ADD_NEW_COMMENTARY: 'liveChat:addNewCommentary',
    INSERTED_LEADERBOARD: 'liveChat:leaderboardInserted',
    UPDATED_LEADERBOARD: 'liveChat:leaderboardUpdated',
    USER_POINT_ADDED: 'liveChat:userPointAdded',
    UPDATED_USER_POINTS: 'liveChat:updatedUserPoints',
    UPDATE_HOME_TEAM_PLAYERS: 'liveChat:updateHomeTeamPlayers',
    UPDATE_AWAY_TEAM_PLAYERS: 'liveChat:updateAwayTeamPlayers',
    UPDATE_POLL: 'liveChat:updatePoll',
    UPDATE_POLL_TOTAL_VOTES: 'liveChat:updatePollTotalVotes',
    UPDATE_POLL_GAME_ID: 'liveChat:updatePollGameId',    
    UPDATE_POLL_BASIC_DETAILS: 'liveChat:updatePollBasicDetails',
    UPDATE_POLL_STATUS: 'liveChat:updatePollStatus',
    CREATE_POLL: 'liveChat:createPoll',
    DELETE_POLL: 'liveChat:deletePoll',
    ADD_POLL_IF_NOT_PRESENT: 'liveChat:addPollIfNotPresent',
    PUSH_AUTOMATED_POLL: 'liveChat:pushAutomatedPoll',
    PULL_AUTOMATED_POLL: 'liveChat:pullAutomatedPoll',
}

export { 
    LIVE_CHAT_CONSTANTS
}